import React, {useRef} from 'react';
import dayjs from 'dayjs';
import {Button, Card, DatePicker, Form, notification} from 'antd';
import {SyncOutlined} from '@ant-design/icons';
import {useTranslation} from 'react-i18next';
import useSWRMutation from 'swr/mutation';
import MyModal from '../Modal';
import {roaming_document_sync} from '../../api/api';
import {triggerAxios, afterRequest} from '../../api/config';

const {RangePicker} = DatePicker;
const DATE_FORMAT = 'YYYY-MM-DD';
const MAX_RANGE_DAYS = 10;

const SyncRoamingDocuments = () => {
    const {t} = useTranslation();
    const ref = useRef();
    const [form] = Form.useForm();
    const {trigger: triggerSync, isMutating: loading} = useSWRMutation(roaming_document_sync, triggerAxios);

    const initialRange = [dayjs().subtract(6, 'day'), dayjs()];

    // Cap the picker so the user can't pick a range wider than the backend allows.
    const disabledDate = (current) => {
        if (!current) return false;
        const range = form.getFieldValue('range');
        const anchor = range && range[0] && !range[1] ? range[0]
                     : range && !range[0] && range[1] ? range[1]
                     : null;
        if (!anchor) return false;
        return Math.abs(current.diff(anchor, 'day')) > MAX_RANGE_DAYS - 1;
    };

    const onFinish = ({range}) => {
        if (!range || !range[0] || !range[1]) return;
        afterRequest(triggerSync, {
            method: 'POST',
            data: {
                date_start: range[0].format(DATE_FORMAT),
                date_end: range[1].format(DATE_FORMAT),
            },
        }, (res) => {
            notification.success({
                message: t('sync'),
                description: `${t('unmatched')}: ${res.unmatched} | ${t('errors')}: ${res.errors}`,
                pauseOnHover: true,
            });
            ref?.current?.closeModal();
        }, (err) => {
            notification.error({
                message: t('sync'),
                description: err?.response?.data?.error || err?.message,
            });
        });
    };

    return (
        <>
            <MyModal modalTitle={t('sync')} button={false} ref={ref}>
                <Card bordered={false}>
                    <Form form={form} layout={'vertical'}
                          initialValues={{range: initialRange}}
                          onFinish={onFinish}>
                        <Form.Item name={'range'} label={t('selectDateRange')}
                                   rules={[{required: true, message: t('required', {input: t('selectDateRange')})}]}>
                            <RangePicker format={DATE_FORMAT} className={'w-100'} size={'large'}
                                         disabledDate={disabledDate}/>
                        </Form.Item>
                        <Form.Item style={{marginBottom: 0}}>
                            <Button type={'primary'} htmlType={'submit'} size={'large'} loading={loading}
                                    icon={<SyncOutlined/>} block>
                                {t('sync')}
                            </Button>
                        </Form.Item>
                    </Form>
                </Card>
            </MyModal>
            <Button size={'large'} icon={<SyncOutlined/>} onClick={() => ref?.current?.openModal()}>
                {t('sync')}
            </Button>
        </>
    );
};

export default SyncRoamingDocuments;
